module.exports = __webpack_public_path__ + "static/egmc-6f9f879f77829ee2bd3c11d8e924895e.png";